import React, { useRef } from "react";
import "./ButtonsBarConnected.scss";
import BtnRond from "../..//Boutons/BtnRond/btn-rond";
import {
  // FaMapMarkerAlt,
  FaDownload,
  FaUsers,
  FaRegCalendarCheck,
  FaEllipsisH,
  FaUserCog,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updateMenu } from "Redux/Actions/menuActions";
import { Menu } from "primereact/menu";

const ButtonsBarConnected = (props) => {
  const menuMobileConnected = useRef(null);
  let itemsMobileConnected = [
    {
      label: "Déposer une offre",
      command: () => {
        if (window.location.pathname != "/offres") {
          window.location.pathname = "/offres";
        }
        props.handleMenu({
          activeItemOffre: props.items.itemsOffre.findIndex(
            (v) => v.label == "Déposer une offre"
          ),
        });
      },
    },
    {
      label: "Mes groupes d'échanges",
      command: () => {
        if (window.location.pathname != "/groupes") {
          window.location.pathname = "/groupes";
        }
        props.handleMenu({
          activeItemGroupes: props.items.itemsGroupes.findIndex(
            (v) => v.label == "Mes groupes d'échanges"
          ),
        });
      },
    },
    {
      label: "Les événements à venir",
      command: () => {
        if (window.location.pathname != "/profil") {
          window.location.pathname = "/profil";
        }
        props.handleMenu({
          activeItemProfil: props.items.itemsProfil.findIndex(
            (v) => v.label == "Mes événements à venir"
          ),
        });
      },
    },
  ];
  return (
    <div className="buttonsBarConnected">
      <div className="buttonsBarConnected__bandeau">
        {/* bandeau avec opacité de l'acceuil une fois connecté */}
      </div>
      <div className="buttons">
        <div className="bouton-cache-mobile">
          <Link to="/profil">
            <BtnRond
              btnAction={() =>
                props.handleMenu({
                  activeItemProfil: props.items.itemsProfil.findIndex(
                    (v) => v.label == "Dernières offres d'emploi"
                  ),
                })
              }
            >
              <FaUserCog size={"2rem"} />
            </BtnRond>
          </Link>
        </div>

        <div className="bouton-cache-mobile">
          <Link to="/offres">
            <BtnRond
              btnAction={() =>
                props.handleMenu({
                  activeItemOffre: props.items.itemsOffre.findIndex(
                    (v) => v.label == "Déposer une offre"
                  ),
                })
              }
            >
              <FaDownload size={"2rem"} />
            </BtnRond>
          </Link>
        </div>

        <div className="bouton-cache-mobile">
          <Link to="/groupes">
            <BtnRond
              btnAction={() =>
                props.handleMenu({
                  activeItemGroupes: props.items.itemsGroupes.findIndex(
                    (v) => v.label == "Mes groupes d'échanges"
                  ),
                })
              }
            >
              <FaUsers size={"2rem"} />
            </BtnRond>
          </Link>
        </div>

        <div className="bouton-cache-mobile">
          <Link to="/profil">
            <BtnRond
              btnAction={() =>
                props.handleMenu({
                  activeItemProfil: props.items.itemsProfil.findIndex(
                    (v) => v.label == "Mes événements à venir"
                  ),
                })
              }
            >
              <FaRegCalendarCheck size={"2rem"} />
            </BtnRond>
          </Link>
        </div>

        {/* <div className="bouton-cache-mobile">
          <BtnRond>
            <FaMapMarkerAlt size={"2rem"} />
          </BtnRond>
        </div> */}

        <div className="bouton-cache-mobile">
          <p>Accéder à mon profil</p>
        </div>
        <div className="bouton-cache-mobile">
          <p>Déposer une offre d&apos;emploi</p>
        </div>

        <div className="bouton-cache-mobile">
          <p>Mes groupes d&apos;échanges</p>
        </div>

        <div className="bouton-cache-mobile">
          <p>Mes événements à venir</p>
        </div>

        {/* <div className="bouton-cache-mobile">
          <p>Trouver des étudiants et des alumnis près de chez moi</p>
        </div> */}

        <div className="bouton-visible-mobile">
          <Link to="/profil-edit">
            <BtnRond
              btnAction={() =>
                props.handleMenu({
                  activeItemProfilEdit: props.items.itemsProfilEdit.findIndex(
                    (v) => v.label == "Informations personnelles"
                  ),
                })
              }
            >
              <FaUserCog size={"2rem"} />
            </BtnRond>
          </Link>
          <p>Gérer mon profil</p>
        </div>
        {/* <div className="bouton-visible-mobile">
          <br />
          <p>Gérer mon profil</p>
        </div> */}
        <div className="bouton-visible-mobile navigation__hamburger">
          <Menu
            appendTo={document.getElementById("app")}
            model={itemsMobileConnected}
            popup
            ref={menuMobileConnected}
            style={{ textAlign: "center", width: "100%", left: "0" }}
          />
          <BtnRond
            // label="Show"
            // icon="pi pi-bars"
            btnAction={
              (event) => menuMobileConnected.current.toggle(event)
              // , setNavBarOpen(!navBarOpen)
            }
          >
            <FaEllipsisH size={"2rem"} />
          </BtnRond>
          <p>Découvrir plus de fonctionnalités</p>
        </div>

        {/* <div className="bouton-visible-mobile">
          <p>Découvrir plus de fonctionnalités</p>
        </div> */}
        {/* <div className="bouton-cache-mobile">
            <BtnRond>
              <FaUserCog size={"2rem"} />
            </BtnRond>
            <p>Pas utilisé ici</p>
          </div> */}
      </div>
    </div>
  );
};

ButtonsBarConnected.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
  handleMenu: PropTypes.func,
  items: PropTypes.object,
};

const mapStateToProps = (state) => ({
  items: state.items,
});

const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ButtonsBarConnected);
